import { isFinite, toNumber } from 'lodash';
import { IGetGroupCompositionCompareItem } from './types/raidTypes';
import { Expansion } from '../../../shared/gameConfig/expansion';
import { RaidDifficulty } from '../../../shared/gameConfig/sharedTypes';

// Item level squishes land on expansion boundaries, so guild item level history can only span the
// expansions the service knows a gear cutoff for.
export const SUPPORTED_GUILD_ILVL_HISTORY_EXPANSIONS = new Set<number>([
  Expansion.Shadowlands,
  Expansion.Dragonflight,
  Expansion.TheWarWithin,
  Expansion.Midnight
]);

export const MAX_GUILDS_TO_COMPARE = 5;
export const MIN_GUILDS_TO_COMPARE = 1;
export const MAX_GUILDS_TO_COMPARE_WITHOUT_PREMIUM = 2;

interface ValidationErrorDetail {
  message: string;
  type: string;
  context?: { key: string };
}

interface ValidationResult<T> {
  error?: { details: ValidationErrorDetail[] };
  value: T;
}

export const groupCompositionCompareItemValidationSchema = {
  validate(value: unknown, _options?: { abortEarly?: boolean }): ValidationResult<IGetGroupCompositionCompareItem> {
    const obj = value as Record<string, unknown>;
    const details: ValidationErrorDetail[] = [];

    const requiredStrings = ['name', 'realm', 'region', 'raid', 'difficulty', 'boss'] as const;
    for (const field of requiredStrings) {
      if (typeof obj[field] !== 'string' || obj[field] === '') {
        details.push({
          message: `"${field}" is required`,
          type: 'any.required',
          context: { key: field }
        });
      }
    }

    if (obj.pull !== undefined) {
      if (typeof obj.pull === 'string' && isFinite(toNumber(obj.pull))) {
        obj.pull = toNumber(obj.pull);
      } else if (typeof obj.pull !== 'number') {
        details.push({
          message: '"pull" must be a number',
          type: 'number.base',
          context: { key: 'pull' }
        });
      }
    }

    return {
      error: details.length > 0 ? { details } : undefined,
      value: obj as unknown as IGetGroupCompositionCompareItem
    };
  }
};

export const getRaidMinMaxGroupMembersCount = (difficulty?: RaidDifficulty) => {
  if (difficulty === RaidDifficulty.MYTHIC) {
    return {
      min: 20,
      max: 20
    };
  }

  return {
    min: 10,
    max: 30
  };
};
